export const formatRupiah = (value: number) => {
  return value.toLocaleString("en-US", { style: "currency", currency: "IDR" });
};
